import { nanoid } from "nanoid";

import type { DocumentFile } from "../../../pages/Documents/schema";

import type { ChatMessage } from "../types";

export type DocumentModalState = {
	isOpen: boolean;
	document: DocumentFile | null;
};

export const initialDocumentModalState: DocumentModalState = {
	isOpen: false,
	document: null,
};

export const buildGreetingMessage = (
	askHrEnabled: boolean,
	goalCreationEnabled: boolean,
	formCreationEnabled: boolean
): ChatMessage => {
	const capabilities: string[] = [];
	if (askHrEnabled) {
		capabilities.push("pull accurate, up-to-date answers from your company's internal documents");
	}
	if (goalCreationEnabled) {
		capabilities.push("help you create actionable goals");
	}
	if (formCreationEnabled) {
		capabilities.push("help admins construct and create forms");
	}

	let content: string;
	if (capabilities.length === 0) {
		content = "Hi there! How can I help you today?";
	} else if (capabilities.length === 1) {
		content = `Hi there! Need help? I can ${capabilities[0]}.`;
	} else {
		const last = capabilities.pop()!;
		const separator = capabilities.length > 1 ? ", or " : " or ";
		content = `Hi there! Need help? I can ${capabilities.join(", ")}${separator}${last}.`;
	}

	return {
		id: "greeting",
		role: "assistant",
		content,
		timestamp: new Date(),
	};
};

export const generateMessageId = (): string => {
	return `msg-${nanoid()}`;
};

// Session ID helpers — persisted in sessionStorage so it survives full page reloads
// (e.g. React ↔ Template page transitions) within the same tab.
const SESSION_ID_KEY = "ask-py-session-id";

export const getOrCreateSessionId = (): string => {
	const existing = sessionStorage.getItem(SESSION_ID_KEY);
	if (existing) return existing;
	const id = nanoid();
	sessionStorage.setItem(SESSION_ID_KEY, id);
	return id;
};

export const resetSessionId = (): string => {
	const id = nanoid();
	sessionStorage.setItem(SESSION_ID_KEY, id);
	return id;
};
